import about1 from '../assets/about/about1.png'
import about2 from '../assets/about/about2.png'
import about3 from '../assets/about/about3.png'
import about4 from '../assets/about/about4.png'
import about5 from '../assets/about/about5.png'
export default
    [
        about1, about2, about3, about4, about5
    ]
